<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-n3">a) Which of the following statements is the most accurate?</p>

      <v-radio-group
        v-model="inputs.multipleChoiceAnswer"
        class="ml-6 mb-0"
        :disabled="!allowEditing"
      >
        <v-radio v-for="option in options" :key="option.value" class="my-1" :value="option.value">
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>

      <p class="mb-2 mt-2">b) I think this because:</p>

      <p class="mb-n6">
        <s-textarea v-model="inputs.explainedResponse" outlined />
      </p>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';
import STextarea from '@/common/components/STextarea.vue';

export default {
  name: 'CalPolyPracticeExam3Q7',
  components: {
    STextarea,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        multipleChoiceAnswer: null,
        explainedResponse: null,
      },
      options: [
        {
          text: 'State functions do not depend on the path taken to arrive at a given state',
          value: 'a',
        },
        {text: 'Energy is neither created nor destroyed', value: 'b'},
        {
          text: '$\\Delta\\text{H}_\\text{rxn}$ can be determined using constant pressure calorimetry',
          value: 'c',
        },
        {text: 'All of the above are true', value: 'd'},
      ],
    };
  },
};
</script>
